import { container } from "tsyringe";

// shared
import StoreManagerImpl from "@/shared/libs/state-management";
import type { CurriculumClientState } from "@/shared/types/features/curriculum-client";
import type { ClientStateManager } from "@/shared/types/adapter/client-interface";

// features
import useCurriculumClientStore from "@/features/curriculum/model/store";

export const registerCurriculumProviders = () => {
    container.register<ClientStateManager.CurriculumClientManager>("CurriculumClientManager", {
        useValue: new StoreManagerImpl<CurriculumClientState>(useCurriculumClientStore()),
    });
};
